const data = [
    {
        key: 'dashboard',
        title: 'Dashboard',
        icon: 'th-large',
        route: 'app.dashboard',
        childrens: []
    },
    {
        key: 'services',
        title: 'Serviços',
        icon: 'briefcase',
        route: 'app.services',
        childrens: [
            {
                key: 100,
                icon: '/svg/menu/sms.svg',
                route: 'app.services.sms',
                title: 'Campanhas',
                description: 'Crie campanhas e envie imediatamente para seus contatos.',
                permition: ['S', 'A', 'C', 'U']
            },
            {
                key: 102,
                icon: '/svg/menu/responses.svg',
                route: 'app.services.responses',
                title: 'Respostas',
                description: 'Consulte as respostas dos SMS e responda a elas.',
                permition: ['S', 'A', 'C', 'U']
            },
            {
                key: 101,
                icon: '/svg/menu/reports.svg',
                route: 'app.services.reports',
                title: 'Relatórios',
                description: 'Consulte seus relatórios e faça uma análise de suas campanhas.',
                permition: ['S', 'A']
            },
            {
                key: 103,
                icon: '/svg/menu/status.svg',
                route: 'app.services.status',
                title: 'Consultar Status',
                description: 'Consulte o status de seus envios por um determinado período.',
                permition: ['S', 'A', 'C', 'U']
            }
        ]
    },
    {
        key: 'contacts',
        title: 'Contatos',
        icon: 'user-friends',
        route: 'app.contacts',
        childrens: [
            {
                key: 200,
                icon: '/svg/menu/contacts.svg',
                route: 'app.contacts.contacts',
                title: 'Contatos',
                description: 'Faça a manutenção, gerenciamento e importação de seus contatos.',
                permition: ['S', 'A', 'C', 'U']
            },
            {
                key: 201,
                icon: '/svg/menu/groups.svg',
                route: 'app.contacts.groups',
                title: 'Grupos',
                description: 'Organize seus contatos por grupos, cada contato pode estar em mais de um grupo.',
                permition: ['S', 'A', 'C', 'U']
            },
            {
                key: 202,
                icon: '/svg/menu/blacklist.svg',
                route: 'app.contacts.blocks',
                title: 'Contatos Bloqueados',
                description: 'Adicione ou remova telefones a sua lista de contatos bloqueados.',
                permition: ['S', 'A', 'C', 'U']
            },
            {
                key: 203,
                icon: '/svg/menu/import.svg',
                route: 'app.contacts.import',
                title: 'Importar',
                description: 'Importe seu contatos e tenha uma agilidade nos processo de cadastro.',
                permition: ['S', 'A', 'U']
            }
        ]
    },
    {
        key: 'settings',
        title: 'Configurações',
        icon: 'sliders-h',
        route: 'app.settings',
        childrens: [
            {
                key: 300,
                icon: '/svg/menu/company.svg',
                route: 'app.settings.company',
                title: 'Empresa',
                description: 'Mantenha os dados de sua empresa sempre atualizados.',
                permition: ['S', 'A']
            },
            {
                key: 302,
                icon: '/svg/menu/users.svg',
                route: 'app.settings.users',
                title: 'Usuários',
                description: 'Gerencie os usuários com permissão de acesso a empresa.',
                permition: ['S', 'A']
            },
            {
                key: 303,
                icon: '/svg/menu/default-message.svg',
                route: 'app.settings.messagedefault',
                title: 'Mensagem Padrão',
                description: 'Gerencie as mensagens padrões utilizar nos envios.',
                permition: ['S', 'A']
            },
            {
                key: 304,
                icon: '/svg/menu/clients.svg',
                route: 'app.settings.clients',
                title: 'Clientes',
                description: 'Gerencie seus clientes, cadastre novos e mantenha sempre atualizados.',
                permition: ['S', 'A', 'C']
            },
            {
                key: 308,
                icon: '/svg/menu/costs.svg',
                route: 'app.settings.costs',
                title: 'Centro de Custos',
                description: 'Gerenciamento o centro de custos da empresas.',
                permition: ['S', 'A']
            },
            {
                key: 309,
                icon: '/svg/menu/credits.svg',
                route: 'app.settings.credits',
                title: 'Créditos',
                description: 'Gerenciamento de créditos para as empresas.',
                permition: ['S', 'A', 'C']
            }
        ]
    }
]

const find = (key) => {
    let search = data.find((item) => {
        return item.key === key
    })
    return search.childrens
}

const findByKeys = (keys) => {
    let itens = []
    data.map((item) => {
        item.childrens.map((i) => {
            if (keys.includes(i.key)) {
                itens.push(i)
            }
        })
    })
    return itens
}

export default {
    data,
    find,
    findByKeys
}
